import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import moment from 'moment'

import { PROJECTS_STATUSES, PROJECT_MODES } from 'constants/projects'

import { TooltipWrapper } from 'components/Tooltip/Tooltip'
import Button from 'components/Forms/Button/Button'
import Toast, { TOAST_TYPE } from 'components/Toast/Toast'

import API from 'api'

import { STATUS } from './constants'

import FlagSVG from './svg/Flag'
import TimerSVG from './svg/Timer'

import styles from './ActivePeriod.module.scss'

const ActivePeriod = ({ project, onRefresh = () => {} }) => {
    const [status, setStatus] = useState(null)

    const [isLoading, setIsLoading] = useState(false)

    const isPublished = project.projectStatus === PROJECTS_STATUSES.PUBLISHED

    useEffect(() => {
        if (isPublished) {
            if (project.limitActivePeriod) {
                if (project.endDate <= Date.now()) {
                    setStatus(STATUS.ENDED)
                    return
                }
                if (project.startDate >= Date.now()) {
                    setStatus(STATUS.SCHEDULED)
                    return
                }
            }
            setStatus(STATUS.LIVE)
            return
        }

        setStatus(null)
    }, [isPublished, project])

    const onDeactivate = async () => {
        try {
            setIsLoading(true)
            await API.PROJECTS.PUBLISH_PROJECT(project.projectId, { deactivate: true })
            onRefresh()
        } catch (err) {
            console.error(err)
            Toast(TOAST_TYPE.ERROR)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className={styles.activePeriod} title="">
            {isPublished && (
                <>
                    {status === STATUS.LIVE && project.mode !== PROJECT_MODES.MULTIPLAYER && (
                        <TooltipWrapper
                            isForcedVisible={isLoading || undefined}
                            tooltipText={
                                <div className={styles.tooltip}>
                                    <Button
                                        isLoading={isLoading}
                                        className={styles.button}
                                        variant="danger"
                                        isInverse
                                        onClick={onDeactivate}
                                    >
                                        End Project
                                    </Button>
                                </div>
                            }
                        >
                            <div className={classNames(styles.box, styles.isLiveBox)}>Live</div>
                        </TooltipWrapper>
                    )}
                    {status === STATUS.SCHEDULED && (
                        <TooltipWrapper
                            isForcedVisible={isLoading || undefined}
                            tooltipText={
                                <div className={styles.tooltip}>
                                    <div className={styles.dates}>
                                        Start:{' '}
                                        <span>
                                            {project.startDate
                                                ? moment(project.startDate).format('MMM D, YYYY (HH:mm)')
                                                : 'N/A'}
                                        </span>
                                        <br />
                                        End:{' '}
                                        <span>
                                            {project.endDate
                                                ? moment(project.endDate).format('MMM D, YYYY (HH:mm)')
                                                : 'N/A'}
                                        </span>
                                    </div>
                                    <Button
                                        isLoading={isLoading}
                                        className={styles.button}
                                        variant="danger"
                                        isInverse
                                        onClick={onDeactivate}
                                    >
                                        End Project
                                    </Button>
                                </div>
                            }
                        >
                            <div className={classNames(styles.box, styles.isScheduledBox)}>
                                <TimerSVG /> Scheduled
                            </div>
                        </TooltipWrapper>
                    )}
                    {status === STATUS.ENDED && (
                        <TooltipWrapper
                            tooltipText={
                                <div className={styles.tooltip}>
                                    <div className={styles.dates}>
                                        Start:{' '}
                                        <span>
                                            {project.startDate
                                                ? moment(project.startDate).format('MMM D, YYYY (HH:mm)')
                                                : 'N/A'}
                                        </span>
                                        <br />
                                        End:{' '}
                                        <span>
                                            {project.endDate
                                                ? moment(project.endDate).format('MMM D, YYYY (HH:mm)')
                                                : 'N/A'}
                                        </span>
                                    </div>
                                </div>
                            }
                        >
                            <div className={classNames(styles.box, styles.isEndedBox)}>
                                <FlagSVG /> Ended
                            </div>
                        </TooltipWrapper>
                    )}
                </>
            )}
            {project.mode === PROJECT_MODES.MULTIPLAYER && (
                <div className={classNames(styles.box, styles.isMultiplayerBox)} title="Multiplayer mode">
                    Multiplayer
                </div>
            )}
            {/*{project.mode === PROJECT_MODES.SINGLE && (*/}
            {/*    <div className={classNames(styles.box, styles.isSingleBox)} title="Single mode">*/}
            {/*        Single*/}
            {/*    </div>*/}
            {/*)}*/}
        </div>
    )
}

export default ActivePeriod
